<template>
	<div class="FanFollowList-box" v-else>
		<div class="list_box" v-if="list && list.length != 0">
			<div class="list_item" v-for="(item, index) in list" :key="index">
			  <div class="information_box" @click="check_information(item)">
					<div class="avatar">
						<img v-if="item.avatar && item.avatar != ''" :src="item.avatar" :alt="'TOZO Community ' + item.nickname + ' User Avatar'"/>
						<i v-else class="el-icon-s-custom"></i>
					</div>
					<div class="name_box">
						<div class="name">{{ item.nickname }}</div>
					</div>
			  </div>
		
				<div class="follow_status_box" :class="get_type() ? 'follow_box' : 'following_followers'">
					<div class="follow_status" @click="change_state(item)" :class="get_type() ? 'Unfollow' : (item.is_focus == 1 ? 'Unfollow' : 'Follow')">
						{{ get_type() ? $t('buttonArr.Unfollow') : (item.is_focus == 1 ? $t('buttonArr.Unfollow') : $t('buttonArr.Follow')) }}
					</div>
				</div>
				<!-- <div class="follow_status_box" :class="get_type() ? 'follow_box' : 'following_followers'">
				  <div class="follow_status" @click="change_state(item)" :class="get_type() ? 'Remove' : (item.is_focus == 1 ? 'Follow' : 'Followed')">
					  {{ get_type() ? 'Remove' : (item.is_focus == 1 ? 'Followed' : 'Follow') }}
				  </div>
				</div> -->
			</div>
		</div>
		
		<NoData v-else :calling_modules="calling_modules"></NoData>
		
	 </div>
</template>

<script>
// import TopNavbar from './components/TopNavbar.vue'
import { post_community_userfollow } from '@/api/community.js'

export default {
	name: 'fan-follow-list',
	// components: { TopNavbar },

	props: {
		Fan_Follow_List: {
			type: Array,
			default: []
		},
		parent_type: {
			type: String,
			default: []
		},
		Loading: {
			type: Boolean,
			default: true,
		},
	},
	data() {
		return {
			calling_modules: this.parent_type,
			list:[]
		}
	},
	
	// 监听
	watch: {
		"Fan_Follow_List": {
			handler: function (newValue, oldValue) {
				console.log(this.Fan_Follow_List)
				this.list = this.Fan_Follow_List
			},
			deep: true
		},
	},
	
	// beforeCreate() {
		
	// }
	
  created () {
	  
  },
  
  mounted() {
	  console.log(this.Fan_Follow_List)
	  this.list = this.Fan_Follow_List
  },
  
  methods:{
	//查看 粉丝或关注人信息
	check_information(item){
		console.log(this.parent_type)
		this.$emit("close_bulletFrame_fun")
		console.log(item)
		
		let routeParams = {
			name: "users",
			params: {
				user_id: item.user_id,
				parent_type: this.parent_type,
				nickname: item.nickname,
			}
		}
		
		if(this.parent_type != "search-user"){
			let path = this.$router.currentRoute.path
			let previous = path ? path.split("/")[1] : ''
			console.log(previous)
			if(previous){
				routeParams.params.previous = previous
			}
		}else{
			routeParams.name = 'search-user'
		}
		console.log(routeParams)
		this.$router.push(routeParams)
	},
	
	//获取父组件类型
	get_type(){
		return this.parent_type == 'follow-list'
	},
	
	//更新关注、取消
	change_state(item){
		console.log(item)
		if(!this.$store.state.userinfo.login_token){
			this.LoginTips()
			return
		}
		if(this.parent_type == 'fans-list' || this.parent_type ==  'search-user'){
			let status = ''
			// is_focus: 0|1, //是否关注, 0否, 1是
			//status	状态 1关注, 2取关
			if(item.is_focus == 0){
				status = 1
			}else{
				status = 2
			}
			// 粉丝列表的点击，已的关注取消关注，未关注的更为关注
			this.post_community_userfollow(item, status)
		}else if(this.parent_type == 'follow-list'){
			// 关注列表的点击取消关注
			this.post_community_userfollow(item, status=2)
		}
	},
	

	//关注/取关用户
	post_community_userfollow(item, status){
		let obj = {
			user_id: item.user_id, 
			status: status,
		}
		console.log(obj)
		post_community_userfollow(obj)
	   .then((res) => {
			console.log(res)
			if(res.code == 0){
				this.$emit('modify_state', 'success')
			}else{
				this.exception_handling(res)
			}
	   })
	   .catch((err) => {
			console.log(err)
			this.exception_handling(err)
	   })
	},
		
	//异常处理
	exception_handling(err){
		this.$errorMessage(err)
		// this.$message('err.data.message', 'error')
	},
	
	LoginTips(){
		if(this.$IsConfirmExecute) { return }
		this.$IsConfirmExecute = true
		this.$MessageBox.confirm(
		   this.$t('ConfirmPrompt.experience_more'),
		   this.$t('ConfirmPrompt.Login_Tips'),
		   {
		      confirmButtonText: this.$t('buttonArr.Confirm'),
		      cancelButtonText: this.$t('buttonArr.Cancel'),
		      type: 'warning',
		   }
		).then((res) => {
			try {
			   // 用户点击了确认按钮
				console.log("用户点击了确认按钮")
				this.$router.replace({
					path: '/login',
					query: {
						redirect: this.$router.currentRoute.fullPath
					}
				})
			} catch (error) {
			   console.error('Error in then block:', error);
			}
			this.$IsConfirmExecute = false
		}).catch((err) => {
		   // 用户点击了取消按钮
			this.$IsConfirmExecute = false
			console.log("用户点击了取消按钮")
		});
		// 主动调用根组件的无障碍修复方法
  		this.$root.set_message_input()
	},
	
  }
}
</script>

<style lang="less" scoped>
	*{
		box-sizing: border-box;
		font-family: Poppins, Poppins;
	}
	.FanFollowList-box {
		width: 100%;
	}
	
	@media screen and (min-width: 1024px) {
		.FanFollowList-box {
			min-height: 250px;
		}
		.list_box{
			/* margin-top: 26px; */
			.title{
				font-weight: 400;
				padding: 0px 10px;
				font-size: 15px;
				color: #000000;
				line-height: 18px;
				text-align: left;
				font-style: normal;
				text-transform: none;
			}
			.list_item{
				margin-top: 10px;
				display: flex;
				padding: 0px 10px;
				display: flex;
				justify-content: space-between;
				display: -webkit-box;
				    display: -webkit-flex;
				    display: -ms-flexbox;
				    display: flex;
				    -webkit-box-pack: center;
				    -webkit-justify-content: center;
				    -ms-flex-pack: center;
				    justify-content: center;
				.information_box{
					display: flex;
					width: calc(100% - 90px);
					.avatar{
						width: 40px;
						height: 40px;
						display: flex;
						justify-content: center;
						align-items: center;
						color: #505050;
						border-radius: 50%;
						overflow: hidden;
						cursor: pointer;
						img{
							width: 100%;
							height: 100%;
						}
						.el-icon-s-custom{
							height: 40px;
							display: flex;
							justify-content: center;
							align-items: center;
							width: 100%;
							height: 100%;
							display: flex;
							justify-content: center;
							align-items: center;
							border: 1px #f5f5f5 solid;
							border-radius: 50%;
							font-size: 20px;
							color: #999;
						}
					}
					.name_box{
						cursor: pointer;
						width: calc(100% - 52px);
						margin-left: 12px;
						height: 40px;
						display: flex;
						justify-content: left;
						align-items: center;
						font-weight: 400;
						font-size: 14px;
						color: #757575;
						line-height: 20px;
						text-align: left;
						font-style: normal;
						text-transform: none;
						.name{
							width: 100%;
							line-height: 1.2;
							white-space: nowrap; 
							overflow: hidden; 
							text-overflow: ellipsis; 
						}
					}
				}
				.follow_status_box{
					display: flex;
					justify-content: center;
					align-items: center;
					.follow_status{
						width: 80px;
						height: 28px;
						font-weight: 400;
						font-size: 12px;
						color: #FFFFFF;
						line-height: 14px;
						text-align: center;
						font-style: normal;
						text-transform: none;
						padding: 5px 15px;
						border-radius: 15px 15px 15px 15px;
						cursor: pointer;
					}
					.Follow{
						color: #ffffff;
						background: #06f;
						border: 1px #06f solid;
						// background: #2094FA;
						// border: 1px #2094FA solid;
					}
					.Remove{
						color: #ffffff;
						background: #000000;
						border: 1px #000000 solid;
					}
					.Followed{
						color: #ffffff;
						background: #06f;
						border: 1px #06f solid;
						// background: #2094FA;
						// border: 1px #2094FA solid;
					}
					.Unfollow{
						color: #06f;
						background: #ffffff;
						border: 1px #06f solid;
						// color: #2094FA;
						// background: #ffffff;
						// border: 1px #2094FA solid;
					}
				}
			}
		}
	}
	
	@media screen and (max-width: 1024px) {
		.FanFollowList-box {
			min-height: calc(100vh - 195px);
		}
		.list_box{
			/* margin-top: 26px; */
			.title{
				font-weight: 400;
				padding: 0px 10px;
				font-size: 14px;
				color: #000000;
				line-height: 18px;
				text-align: left;
				font-style: normal;
				text-transform: none;
			}
			.list_item{
				margin-top: 10px;
				display: flex;
				padding: 0px 0px;
				display: flex;
				justify-content: space-between;
				.information_box{
					display: flex;
					width: calc(100% - 90px);
					.avatar{
						width: 40px;
						height: 40px;
						display: flex;
						justify-content: center;
						align-items: center;
						color: #505050;
						border-radius: 50%;
						overflow: hidden;
						cursor: pointer;
						img{
							width: 100%;
							height: 100%;
						}
						.el-icon-s-custom{
							height: 40px;
							display: flex;
							justify-content: center;
							align-items: center;
							width: 100%;
							height: 100%;
							display: flex;
							justify-content: center;
							align-items: center;
							border: 1px #ffffff solid;
							border-radius: 50%;
							font-size: 20px;
							color: #999;
						}
					}
					.name_box{
						cursor: pointer;
						width: calc(100% - 52px);
						margin-left: 12px;
						height: 40px;
						display: flex;
						justify-content: left;
						align-items: center;
						font-weight: 400;
						font-size: 14px;
						color: #757575;
						line-height: 20px;
						text-align: left;
						font-style: normal;
						text-transform: none;
						.name{
							width: 100%;
							line-height: 1;
							white-space: nowrap; 
							overflow: hidden; 
							text-overflow: ellipsis; 
						}
					}
				}
				.follow_status_box{
					display: flex;
					justify-content: center;
					align-items: center;
					.follow_status{
						width: 80px;
						height: 28px;
						font-weight: 400;
						font-size: 12px;
						color: #FFFFFF;
						line-height: 14px;
						text-align: center;
						font-style: normal;
						text-transform: none;
						padding: 5px 15px;
						border-radius: 15px 15px 15px 15px;
						cursor: pointer;
					}
					.Follow{
						color: #ffffff;
						background: #06f;
						border: 1px #06f solid;
						// background: #2094FA;
						// border: 1px #2094FA solid;
					}
					.Remove{
						color: #ffffff;
						background: #000000;
						border: 1px #000000 solid;
					}
					.Followed{
						color: #ffffff;
						background: #06f;
						border: 1px #06f solid;
						// background: #2094FA;
						// border: 1px #2094FA solid;
					}
					.Unfollow{
						color: #06f;
						background: #ffffff;
						border: 1px #06f solid;
						// color: #2094FA;
						// background: #ffffff;
						// border: 1px #2094FA solid;
					}
				}
			}
		}
	}
</style>
